import { t } from "app/utils";

import lunchImg from "images/event/GroupLunch.jpg";
import socialImg from "images/event/SocialGathering.jpg";
import wellnessImg from "images/event/HealthWellness.jpg";
import charityImg from "images/event/CharityVolunteer.jpg";
import learningImg from "images/event/LunchAndLearn.jpg";
import coffeeImg from "images/event/CoffeeChat.jpg";
import teamBuildingImg from "images/event/TeamBuilding.jpg";
import trainingImg from "images/event/Training.png";
import workshopImg from "images/event/Workshop.jpg";
import sportAndFitnessImg from "images/event/SportsFitness.jpg";
import meetingImg from "images/event/Meeting.jpg";
import networkingImg from "images/event/Networking.jpg";
import conferenceImg from "images/event/Conference.jpg";
import otherImg from "images/event/other.jpg";

const buildUrl = path => ({ originalUrl: `${document.location.origin}${path}` });
const ONE_HOUR_DURATION = 1;
const THREE_HOURS_DURATION = 3;
const TWELVE_PM = 12;
const FIVE_PM = 17;
const THIRTY_MINUTES = 30;
const ONE_DAY = 1;

const dateAtHours = (date, hours, minutes = 0) => (
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0)
);

export const getDefaultStartsAt = () => {
  const startsAt = new Date();

  return dateAtHours(startsAt, startsAt.getHours() + ONE_HOUR_DURATION);
};

const getDefaultTimes = duration => {
  const startsAt = getDefaultStartsAt();

  const endsAt = new Date(startsAt);
  endsAt.setHours(startsAt.getHours() + duration);

  return { startsAt: startsAt.toISOString(), endsAt: endsAt.toISOString() };
};

const getDefaultTimeAfterOffice = () => {
  let startsAt = new Date();

  if (startsAt.getHours() >= FIVE_PM) {
    startsAt.setDate(startsAt.getDate() + ONE_DAY);
  }
  startsAt = dateAtHours(startsAt, FIVE_PM, THIRTY_MINUTES);

  const endsAt = new Date(startsAt);
  endsAt.setHours(endsAt.getHours() + THREE_HOURS_DURATION);

  return { startsAt: startsAt.toISOString(), endsAt: endsAt.toISOString() };
};

const eventTypes = [
  {
    value: "Social Gathering",
    label: t("Social Gathering"),
    description: t("Happy hours, drinks after work, team outings, gatherings, etc"),
    image: socialImg,
    defaults: () => ({
      eventType: "Social Gathering",
      image: buildUrl(socialImg),
      ...getDefaultTimeAfterOffice()
    })
  },
  {
    value: "Coffee Chat",
    label: t("Coffee Chat"),
    description: t("Meetings over coffee or tea"),
    image: coffeeImg,
    defaults: () => {
      const startsAt = getDefaultStartsAt();

      const endsAt = new Date(startsAt);
      endsAt.setMinutes(startsAt.getMinutes() + THIRTY_MINUTES);

      return {
        eventType: "Coffee Chat",
        image: buildUrl(coffeeImg),
        name: t("Meet for Coffee"),
        startsAt: startsAt.toISOString(),
        endsAt: endsAt.toISOString()
      };
    }
  },
  {
    value: "Group Lunch",
    label: t("Group Lunch"),
    description: t("Team lunches, catered lunches, casual lunches with friends"),
    image: lunchImg,
    defaults: () => {
      let startsAt = new Date();

      if (startsAt.getHours() >= TWELVE_PM) {
        startsAt.setDate(startsAt.getDate() + ONE_DAY);
      }
      startsAt = dateAtHours(startsAt, TWELVE_PM);

      const endsAt = new Date(startsAt);
      endsAt.setHours(endsAt.getHours() + ONE_HOUR_DURATION);

      return {
        eventType: "Group Lunch",
        image: buildUrl(lunchImg),
        name: t("Lunch Time!"),
        startsAt: startsAt.toISOString(),
        endsAt: endsAt.toISOString()
      };
    }
  },
  {
    value: "Meeting",
    label: t("Meeting"),
    description: t("Group and team meetings, organization-wide gatherings"),
    image: meetingImg,
    defaults: () => ({
      eventType: "Meeting",
      image: buildUrl(meetingImg),
      ...getDefaultTimes(ONE_HOUR_DURATION)
    })
  },
  {
    value: "Team Building",
    label: t("Team Building"),
    description: t("Team-specific offsites, competitions, relationship-building, etc."),
    image: teamBuildingImg,
    defaults: () => ({
      eventType: "Team Building",
      image: buildUrl(teamBuildingImg),
      ...getDefaultTimeAfterOffice()
    })
  },
  {
    value: "Charity and Volunteer",
    label: t("Charity & Volunteer"),
    description: t("Volunteer days, donations, fundraisers, goodwill, etc"),
    image: charityImg,
    defaults: () => ({
      eventType: "Charity and Volunteer",
      image: buildUrl(charityImg),
      ...getDefaultTimes(THREE_HOURS_DURATION)
    })
  },
  {
    value: "Lunch and Learn",
    label: t("Lunch & Learn"),
    description: t("Meetings, seminars, trainings, hackathons, etc"),
    image: learningImg,
    defaults: () => ({
      eventType: "Lunch and Learn",
      image: buildUrl(learningImg),
      ...getDefaultTimes(THREE_HOURS_DURATION)
    })
  },
  {
    value: "Training",
    label: t("Training"),
    description: t("Guest lectures, internal presentations, training videos, etc."),
    image: trainingImg,
    defaults: () => ({
      eventType: "Training",
      image: buildUrl(trainingImg),
      ...getDefaultTimes(ONE_HOUR_DURATION)
    })
  },
  {
    value: "Workshop",
    label: t("Workshop"),
    description: t("Hands-on learning programs"),
    image: workshopImg,
    defaults: () => ({
      eventType: "Workshop",
      image: buildUrl(workshopImg),
      ...getDefaultTimes(ONE_HOUR_DURATION)
    })
  },
  {
    value: "Sports and Fitness",
    label: t("Sports & Fitness"),
    description: t("Runs, 5k races, athletic games, sports viewing parties, etc."),
    image: sportAndFitnessImg,
    defaults: () => ({
      eventType: "Sports and Fitness",
      image: buildUrl(sportAndFitnessImg),
      ...getDefaultTimeAfterOffice()
    })
  },
  {
    value: "Health and Wellness",
    label: t("Health & Wellness"),
    description: t("Yoga, meditation, walking, healthy habits, diet and nutrition contests, etc."),
    image: wellnessImg,
    defaults: () => ({
      eventType: "Health and Wellness",
      image: buildUrl(wellnessImg),
      ...getDefaultTimes(THREE_HOURS_DURATION)
    })
  },
  {
    value: "Networking",
    label: t("Networking"),
    description: t("Programs to meet colleagues, events with guests"),
    image: networkingImg,
    defaults: () => ({
      eventType: "Networking",
      image: buildUrl(networkingImg),
      ...getDefaultTimeAfterOffice()
    })
  },
  {
    value: "Conference",
    label: t("Conference"),
    description: t("Large-scale onsite or offsite events with employees and guests"),
    image: conferenceImg,
    defaults: () => ({
      eventType: "Conference",
      image: buildUrl(conferenceImg),
      ...getDefaultTimeAfterOffice()
    })
  },
  {
    value: "Other",
    label: t("Other"),
    description: t("Other Events..."),
    image: otherImg,
    defaults: () => ({
      eventType: "Other",
      image: buildUrl(otherImg),
      ...getDefaultTimes(THREE_HOURS_DURATION)
    })
  }
];

export default eventTypes;
